var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"title":"Sign Out","color":"primary","dense":"","left":""},on:{"click":_vm.signOut}},[_vm._v("mdi-logout")])}
var staticRenderFns = []

export { render, staticRenderFns }